// assets
import { UsergroupAddOutlined, MedicineBoxOutlined } from '@ant-design/icons';

// icons
const icons = {
    UsergroupAddOutlined,
    MedicineBoxOutlined
};
const children = [
    {
        id: 'menuStatus',
        title: 'Menu',
        type: 'collapse',
        url: '#',
        breadcrumbs: false,
        children: [
            {
                id: 'module-permission',
                title: 'Feature Status',
                type: 'item',
                url: '/dashboard/module-permissions',
                breadcrumbs: false
            },
            {
                id: 'projectManagement',
                title: 'Project Management',
                type: 'item',
                url: '/dashboard/project-management',
                icon: icons.projectManagementOutlined,
                breadcrumbs: false
            },
            {
                id: 'notice',
                title: 'Notice',
                type: 'item',
                url: '/dashboard/notice',
                breadcrumbs: false
            },
            {
                id: 'AllKnowledge',
                title: 'All Knowledge',
                type: 'item',
                url: '/dashboard/all-knowledge',
                breadcrumbs: false
            },
            {
                id: 'movements',
                title: 'Movements & Visits',
                type: 'item',
                url: '/dashboard/movements',
                breadcrumbs: false
            },
            {
                id: 'adminPeopleVoice',
                title: 'People Voice',
                type: 'item',
                url: '/dashboard/admin-people-voices',
                breadcrumbs: false
            },

            // {
            //     id: 'footNote',
            //     title: 'FootNotes',
            //     type: 'item',
            //     url: '/dashboard/footnotes',
            //     breadcrumbs: false
            // },
            {
                id: 'AppStore',
                title: 'App Store',
                type: 'item',
                url: '/dashboard/app-store',
                breadcrumbs: false
            }
        ]
    }
];
const MenuStatus = {
    id: 'menuStatus',
    title: 'Menu Status',
    type: 'group',
    icon: icons.MedicineBoxOutlined,
    children: children
};

export default MenuStatus;
